import React from 'react';
import { useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { loadGpr, loadGprRun } from 'pages/PageGpr/api';
import { IGpr, IGprRunCard } from 'pages/PageGpr/interfaces';

export const path = '/gpr/run/:runId';
export const getPath = (runId: number): string => `/gpr/run/${runId}`;

// Карточка запуска (GprRunCardDto) не содержит названия работы и периодичности графика —
// только gprId, поэтому шапка карточки догружает сам график тем же loadGpr, что и форма
// (решение координатора задачи 12). Второй запрос зависит от ответа первого, поэтому
// Loadable.Map получает уже собранную пару, а не два независимых загрузчика.
const loadRunCard = (runId: string): Promise<{ run: IGprRunCard; gpr: IGpr }> =>
  loadGprRun(Number(runId)).then((run) => loadGpr(run.run.gprId).then((gpr) => ({ run, gpr })));

const PageGprRun: React.FC = (props) => {
  const { runId } = useParams<{ runId: string }>();

  const GprRun = Loadable.Map({
    loader: {
      page: () => import('./page'),
      runCard: () => loadRunCard(runId),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} run={loaded.runCard.run} gpr={loaded.runCard.gpr} />;
    },
  });

  // key — как в PageGprForm: при переходе между запусками Loadable.Map должен перезагрузить
  // данные, а не переиспользовать карточку предыдущего запуска.
  return <GprRun key={runId} {...props} />;
};

export default PageGprRun;
